//
//
//
//
//
//


export default {
  components: {
    
  },
  props: {},
  data() {
    return {
      imgsrc:'',
    };
  },
  watch: {
    //观察Vue实例上的数据变动
  },
  computed: {
    //DOM加载后马上执行能够缓存数据
  },
  methods: {
    //触发事件
    // callback(img){
		// 	this.imgsrc=img
		// 	//console.log(imgss)
		// }
  },
  created() {
    //页面渲染前调用
  },
  mounted() {
    //页面渲染完成调用
  }
};



// WEBPACK FOOTER //
// ./src/pages/cs.vue